module.exports = __webpack_public_path__ + "app/kiss-user/kiss-user-detail-21qMrVoq.html";